// src/components/Travel/Accomodations/dummyAccommodationImages.ts

export const DUMMY_ACCOMMODATION_IMAGES: string[] = [
  "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1501117716987-c8e1ecb210d4?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1551887373-6f5d2c3b7a39?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1200&q=70",
];

function cleanStrings(list?: any): string[] {
  if (!Array.isArray(list)) return [];
  return list
    .map((x) => (typeof x === "string" ? x.trim() : ""))
    .filter(Boolean);
}

/**
 * ✅ Rule:
 * - If images[] has at least 1 URL -> return it (NO dummy, NO padding)
 * - Else if imageUrl exists -> return [imageUrl]
 * - Else -> return dummy set
 */
export function normalizeAccommodationImages(
  images?: string[],
  imageUrl?: string,
) {
  const real = cleanStrings(images);
  if (real.length > 0) return real;

  if (typeof imageUrl === "string" && imageUrl.trim()) return [imageUrl.trim()];

  return DUMMY_ACCOMMODATION_IMAGES.slice(0, 8);
}
